<template>
  <b-card>
    <FormBuilder
      label="Voucher"
      create
      :fields="fields"
      :loading-submit="$store.state.voucherV2.loadingSubmit"
      @submit="submitData"
    />
  </b-card>
</template>

<script>
import FormBuilder from '@/layouts/components/v2/FormBuilder.vue'

import {
  BCard,
} from 'bootstrap-vue'

import fields from '@/field/form/voucher'

export default {
  components: {
    BCard,
    FormBuilder,
  },
  setup() {
    return {
      fields,
    }
  },
  methods: {
    submitData(data, callback) {
      this.$store.dispatch('voucherV2/create', data)
        .then(() => {
          if (typeof callback === 'function') callback()
        })
        .catch(err => callback(err))
    },
  },
}
</script>

<style scoped>

</style>
